import React, { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { playPause, updateColor } from '../../../redux/slices/visualSlice';

const BubbleSort = ({ countIterations }) => {
  const myState = useSelector(state => state.updateProps);
  const dispatch = useDispatch();
  const timeoutsRef = useRef([]);
  const cancelledRef = useRef(false);

  const clearAllTimeouts = () => {
    cancelledRef.current = true;
    timeoutsRef.current.forEach(clearTimeout);
    timeoutsRef.current = [];
  };

  const schedule = (fn, delay) => {
    if (cancelledRef.current) return;
    const id = setTimeout(() => {
      if (!cancelledRef.current) fn();
    }, delay);
    timeoutsRef.current.push(id);
  };

  const solve = () => {
    const values = myState.values.map(item => item[0]);
    const ids = myState.values.map(item => item[1]);
    const speed = myState.speed;
    const color = myState.color;

    for (let i = values.length, timer = 0; i > 0; timer += i - 1, i--) {
      schedule(() => {
        for (let j = 1; j < i; j++) {
          schedule(() => {
            countIterations(j - 1);
            document.getElementById(ids[j]).childNodes[1].style.backgroundColor = 'black';
            document.getElementById(ids[j - 1]).childNodes[1].style.backgroundColor = 'black';

            schedule(() => {
              document.getElementById(ids[j]).childNodes[1].style.backgroundColor = color;
              document.getElementById(ids[j - 1]).childNodes[1].style.backgroundColor = color;
            }, speed - 10);

            if (values[j] < values[j - 1]) {
              [values[j], values[j - 1]] = [values[j - 1], values[j]];
              [ids[j], ids[j - 1]] = [ids[j - 1], ids[j]];

              document.getElementById(ids[j]).style.transform = `translateX(${j * 11}px)`;
              document.getElementById(ids[j - 1]).style.transform = `translateX(${(j - 1) * 11}px)`;
            }
          }, (j - 1) * speed);
        }
      }, timer * speed);
    }

    schedule(() => {
      dispatch(playPause(false));
      dispatch(updateColor('rgb(0, 182, 0)'));
    }, (((values.length - 1) * values.length) / 2) * speed + 50);
  };

  useEffect(() => {
    if (myState.algorithm === 'bubble' && myState.play) {
      clearAllTimeouts();
      cancelledRef.current = false;
      solve();
    }
    return clearAllTimeouts;
  }, [myState.play]);

  useEffect(() => {
    return clearAllTimeouts;
  }, [myState.algorithm, myState.values]);

  return <></>;
};

export default BubbleSort;
